import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { ChartStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Reseet charts state and unset key storage
 */
export const chartUnsetKeyStorage = createAction(
  ChartStoreAction.CHART_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const chartLoadInitStartAction = createAction(
  ChartStoreAction.CHART_LOAD_INIT_START
);

/**
 * Action to load full list of charts
 */
export const chartLoadListFromApiAction = createAction(
  ChartStoreAction.CHART_LOAD_FROM_API
);

/**
 * Action to load last modified list of charts
 */
export const chartLoadLastModifiedFromApiAction = createAction(
  ChartStoreAction.CHART_LOAD_LAST_MODIFIED_FROM_API,
  props<{ chartObject: GenericApiData }>()
);

/**
 * Action success chart load success
 */
export const chartLoadSuccessAction = createAction(
  ChartStoreAction.CHART_LOAD_SUCCESS,
  props<{ chartObject: GenericApiData }>()
);

/**
 * Action success chart load error
 */
export const chartLoadErrorAction = createAction(
  ChartStoreAction.CHART_LOAD_ERROR,
  props<{ chartObject: GenericApiData }>()
);
